import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useMemo } from 'react'
import { toast } from 'react-toastify'
import i18n from '../../i18n'
import { mapValuesToSelectOptions } from '../../utils/formUtils/forms'
import { updateToast } from '../helpers'
import { fetchAiValues, generateDescription } from './functions'
import { AiValuesData, GenerateDescriptionPayload, GenerateDescriptionResponse } from './types'

const ai = {
    GenerateDescription: {
        useMutation: (options?: UseMutationOptions<GenerateDescriptionResponse, AxiosError, GenerateDescriptionPayload>) =>
            useMutation({
                onMutate: () => {
                    const toastId = toast.loading(i18n.t('toast.ai.description.loading') as string)
                    return toastId
                },
                mutationFn: (payload) => generateDescription(payload),
                onSuccess: (data, variables, context) => {
                    const toastId = context as number
                    toastId && updateToast(toastId, i18n.t('toast.ai.description.success') as string, 'success')
                },
                onError: (error, variables, context) => {
                    const toastId = context as number
                    toastId && updateToast(toastId, i18n.t('toast.ai.description.error') as string, 'error')
                },
                ...options,
            }),
    },
    FormValues: {
        useQuery: (
            fields?: string[],
            formFilters?: Record<string, string | string[]>,
            options?: Omit<UseQueryOptions<AiValuesData, AxiosError>, 'queryKey' | 'queryFn'>
        ) => {
            const query = useQuery({
                queryKey: ['aiValues', fields, formFilters],
                queryFn: () => fetchAiValues(fields, formFilters),
                staleTime: Infinity,
                gcTime: Infinity,
                ...options,
            })

            const formattedData = useMemo(() => {
                return mapValuesToSelectOptions(query.data)
            }, [query.data])

            return {
                ...query,
                data: formattedData,
            }
        },
    },
}

export default ai
